"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentCard = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CardModal = require("./_CardModal");
var _CardContent = require("./CardContent");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ComponentCard = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    componentId,
    showCloseBtn = false
  } = _ref;
  const [open, setOpen] = (0, _react.useState)(false);
  const handleOpenModal = v => setOpen(v);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CardContent.CardContent, {
    handleOpenModal: handleOpenModal,
    componentId: componentId,
    showCloseBtn: showCloseBtn
  }), /*#__PURE__*/_react.default.createElement(_CardModal._CardModal, {
    open: open,
    handleOpenModal: handleOpenModal,
    componentId: componentId
  }));
});
exports.ComponentCard = ComponentCard;
ComponentCard.propTypes = {
  componentId: _propTypes.default.string,
  showCloseBtn: _propTypes.default.bool
};